import React from 'react';
import classNames from 'classnames';

// Glyphs come from Europcar's own icon font (src/ui/assets/emobg-icons.woff).
// Names are the ones the app already uses — mostly Bronson's — and each is
// mapped to a Europcar glyph in theme.css under "Icons". An unknown name
// renders nothing rather than failing.
export type IconName = string;

export interface IconProps extends React.HTMLAttributes<HTMLElement> {
  name?: IconName;
  testId?: string;
}

export function Icon({ name, className, testId, ...otherProps }: IconProps) {
  return (
    <i
      {...otherProps}
      aria-hidden="true"
      data-testid={testId}
      className={classNames('ec-icon', name && `ec-icon--${name}`, className)}
    />
  );
}
